require('./retailLoanProductInfo.scss');

//@vendor
const React = require('react');
const PropTypes = require('prop-types');
// @core
const { FormattedText, formatText } = require('core/i18n').i18n;
//@commons
const OKModal = require('components/commons/OKModal/OKModal');
//@utilities
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const {
    recordProcess,
    recordLinkV2,
    PROC_CONTRACT_RETAIL_LOAN,
} = require('utilities/tagging');
//@components
const { RetailLoanImageGalleryContainer } = require('../retailLoanImageGalleryContainer/retailLoanImageGalleryContainer');
const { RetailLoanCatalogModal } = require('../retailLoanCatalogModal/retailLoanCatalogModal');
const { RetailLoanPickupPicker } = require('../retailLoanPickupPicker/retailLoanPickupPicker');
const { ContractLoanPdfViewer } = require('../../contractLoanPdfViewer/contractLoanPdfViewer');
const { RetailLoanProductAsideInfo } = require('./retailLoanProductAsideInfo/retailLoanProductAsideInfo');
const { RetailLoanPromotionInfo } = require("./retailLoanPromotionInfo/retailLoanPromotionInfo");
//@helpers
const {
    buildLoadProductSpecificationsView,
    buildEventClickModalSpecificationsContinue,
    buildEventsModal,
} = require('../../../../loansUtilities/loansHelper');
//@constants
const {
    retailLoanGallery: { MAIN_IMAGE_WIDTH_IN_INFO },
    retailLoanDoTaggin: {
        LOAD_MODAL_TERMS_CONDITIONS,
        NAME_PAGE_SPECIFICATIONS_VIEW,
    },
} = require('../../../../loansConstants/index');

class RetailLoanProductInfo extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            showPickupModal: false,
            showModal: false,
        }

        this.handleAgreeCheckboxChange = this.handleAgreeCheckboxChange.bind(this);
        this.handleContinue = this.handleContinue.bind(this);
        this.handleOpenModalListDealers = this.handleOpenModalListDealers.bind(this);
        this.handleToggleModal = this.handleToggleModal.bind(this);
    }

    componentDidMount() {
        const {
            immItem,
            getTermConditionDocuments,
            setDeliveryDate,
        } = this.props;

        const customDataEvent = buildLoadProductSpecificationsView(immItem);

        const customData = {
            ...customDataEvent,
            event_name: "step_productpage",
            pageName: "/openMarketsInformation/step0/productPage",
            sectionFamily: "banking",
            sectionCategory: "products",
            sectionName: "loans",
            serviceType: "productContracting",
            interactionType: "funnel",
            processType: "openMarketsInformation",
            processStep: "step0",
            processDetail: "productPage",
            productName: "openMarkets",
        };
        recordProcess(PROC_CONTRACT_RETAIL_LOAN, null, customData, true);
        getTermConditionDocuments();

        if (setDeliveryDate) {
            setDeliveryDate({ deliveryDate: immItem.get('deliveryDate') });
        }

        scrollToTop();
    }

    componentWillUnmount() {
        this.props.resetDocumentsAndAgreeCheckBox();
    }

    handleContinue() {
        const { validateAgreeCheckBox } = this.props;

        validateAgreeCheckBox();
    }

    handleAgreeCheckboxChange() {
        this.props.setAgree();
    }

    handleOpenModalListDealers() {
        this.setState({
            showPickupModal: !this.state.showPickupModal
        });
    }


    buildProducDetail() {
        const { immItem } = this.props;
        const fieldProductsDetail = immItem.get('field_product_detail');

        return fieldProductsDetail.map((detail, idx) => (
            <li className="retail-loan-product__info-detail-product-li" key={idx}>
                <span className="retail-loan-product__info-detail-product-li-child">
                    {detail}
                </span>
            </li>
        ))
    }

    buildTitle(title) {
        return (
            <React.Fragment>
                <h3 className="retail-loan-product__link-as-title">
                    {title}
                </h3>
                <span className="retail-loan-product__separator" />
            </React.Fragment>
        );
    }

    buildProduct() {
        const { immRetailLoan, immItem, labels } = this.props;

        const title = labels.title;
        const titleComponent = this.buildTitle(title);
        const producDetail = this.buildProducDetail();
        const productDescription = !!immItem.get('field_product_description') ? immItem.get('field_product_description') : null;

        return (
            <React.Fragment>
                <div className="col-md-5">
                    <RetailLoanImageGalleryContainer
                        immRetailLoan={immRetailLoan}
                        immItem={immItem}
                        listImages={immItem.get('field_product_images')}
                        zoomSide="modal"
                        zoom
                        modalMoreInformation
                        mainImageWidth={MAIN_IMAGE_WIDTH_IN_INFO}
                    />
                </div>
                <div className="retail-loan-catalog-modal__container-detail retail-loan-product__gallery col-md-1" />
                <div className="retail-loan-product__info-container-detail retail-loan-product__gallery-info col-md-6 col-lg-6">
                    <div className="retail-loan-product__info-detail-product">
                        {titleComponent}
                        <div className="retail-loan-product__info-container-list">
                            {productDescription}
                            <ul className="retail-loan-product__info-detail-product-ul">
                                {producDetail}
                            </ul>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    buildPdfViewer() {
        const { immRetailLoan, onPrintDocument, onDownloadDocumentTermCondition,
            getTermConditionDocuments } = this.props;
        const documentsTermConditions = immRetailLoan.get('documentsTermConditions');
        const agreeCheckbox = immRetailLoan.get('agree');
        const title = formatText('retailLoanCommon-termAndConditionsTitle');
        const validate = immRetailLoan.get('agreeError');
        const isLoading = immRetailLoan.get('isFetchingDocumentsTermConditions');
        const errorLoading = immRetailLoan.get('errorDocumentsTermConditions');
        const checkboxLabel = (<FormattedText value="retailLoanCommon-termAndConditionscheckboxLabel" />);

        return (
            <ContractLoanPdfViewer
                onAgreeCheckbox={this.handleAgreeCheckboxChange}
                agreeCheckbox={agreeCheckbox}
                document={documentsTermConditions}
                isLoading={isLoading}
                errorLoading={errorLoading}
                getDocuments={getTermConditionDocuments}
                scale={1.7}
                title={title}
                checkboxLabel={checkboxLabel}
                validate={validate}
                onPrint={onPrintDocument}
                onDownload={onDownloadDocumentTermCondition}
            />
        );
    }

    buildPickupModal() {
        const { immItem } = this.props;
        const immOffice = immItem.getIn(['field_retail_provider', 'office_location']);
        const { showPickupModal } = this.state;
        const title = formatText('retailLoanCommon-retailLoanCommon_pickerTitle');
        const description = formatText('retailLoanCommon-retailLoanCommon_pickerDescription');
        const content = (
            <div className="retail-loan-product-info__pickup-container">
                <RetailLoanPickupPicker immOffice={immOffice} />
            </div>
        );

        return (
            <OKModal
                content={content}
                contentOverflow="auto"
                description={description}
                isOpen={showPickupModal}
                onCloseCallback={this.handleOpenModalListDealers}
                size="large"
                shouldCloseOnOverlayClick
                title={title}
            />
        );
    }

    handleToggleModal(typeEvent) {
        const { immItem, resetDocumentsAndAgreeCheckBox } = this.props;
        let customData;
        if (typeEvent) {
            customData = buildEventsModal(LOAD_MODAL_TERMS_CONDITIONS, typeEvent, NAME_PAGE_SPECIFICATIONS_VIEW);
        } else {
            customData = buildEventClickModalSpecificationsContinue(immItem);
        }
        recordLinkV2(customData);
        resetDocumentsAndAgreeCheckBox();

        this.setState({
            showModal: !this.state.showModal
        });
    }

    buildModal() {
        const {
            setPurpose,
            setDeliveryDate,
            labels,
            immRetailLoan,
            getTermConditionDocuments,
            setAgree,
            validateAgreeCheckBoxModal,
            onPrintDocument,
            onDownloadDocumentTermCondition,
            immItem,
            showInfoProduct,
        } = this.props;
        const { showModal } = this.state;

        return (
            <RetailLoanCatalogModal
                item={immItem}
                labels={labels}
                showModal={showModal}
                onHandleToggleModal={this.handleToggleModal}
                setPurpose={setPurpose}
                setDeliveryDate={setDeliveryDate}
                immRetailLoan={immRetailLoan}
                getTermConditionDocuments={getTermConditionDocuments}
                validateAgreeCheckBoxModal={validateAgreeCheckBoxModal}
                setAgree={setAgree}
                onPrintDocument={onPrintDocument}
                onDownloadDocumentTermCondition={onDownloadDocumentTermCondition}
                showInfoProduct={showInfoProduct}
            />
        );
    }

    render() {
        const { immItem, labels, immRetailLoan, highlightText } = this.props;

        const content = this.buildProduct();
        const pickupModal = this.buildPickupModal();
        const promotionData =
            immRetailLoan.toJS().commercialProducts.length > 0
                ? {
                      content:
                          immRetailLoan.toJS().commercialProducts[0].content
                              .description.body,
                      endDate:
                          immRetailLoan.toJS().commercialProducts[0].content
                              .valid_period.text +
                          " " +
                          immRetailLoan.toJS().commercialProducts[0].content
                              .valid_period.date.end_value,
                      cmsId: immRetailLoan.toJS().commercialProducts[0].cms_id,
                  }
                : null;

        return (
            <div className="row">
                {this.buildModal()}
                <section className="ok-section-box retail-loan-product__info col-xs-9">
                    <div className="row">
                        <div className="col-md-12 col-lg-12 retail-loan-product__content-specifics-section">
                            {content}
                        </div>
                    </div>
                    {pickupModal}
                </section>
                <aside className="col-xs-3">
                    <RetailLoanProductAsideInfo
                        immItem={immItem}
                        immRetailLoan={immRetailLoan}
                        labels={labels}
                        onHandleOpenModalListDealers={this.handleOpenModalListDealers}
                        onHandleToggleModal={this.handleToggleModal}
                        highlightText={highlightText}
                    />
                    {promotionData ? (
                        <RetailLoanPromotionInfo {...promotionData} />
                    ) : undefined}
                </aside>
            </div>
        );
    }
}

RetailLoanProductInfo.propTypes = {
    immRetailLoan: PropTypes.object.isRequired,
    immItem: PropTypes.object.isRequired,
    labels: PropTypes.object.isRequired,
    termsAndConditionsUrl: PropTypes.string,
    setDeliveryDate: PropTypes.func.isRequired,
    showInfoProduct: PropTypes.func.isRequired,
    resetLoanPorpuse: PropTypes.func.isRequired,
    getTermConditionDocuments: PropTypes.func.isRequired,
    validateAgreeCheckBox: PropTypes.func.isRequired,
    setAgree: PropTypes.func.isRequired,
    resetDocumentsAndAgreeCheckBox: PropTypes.func.isRequired,
    onPrintDocument: PropTypes.func.isRequired,
    onDownloadDocumentTermCondition: PropTypes.func.isRequired,
    setPurpose: PropTypes.func,
    validateAgreeCheckBoxModal: PropTypes.func.isRequired,
    highlightText: PropTypes.string,
};


module.exports = RetailLoanProductInfo;
